import {formatDateTime, random, round2} from "../helpers/helpers";

export const generateBmsLatestDataDemo = ({ meter_id }) => {
    const now = new Date();

    return {
        meter_id: Number(meter_id),
        meter_name: meter_id == 305 ? "DG BATTERY" : "Fire Battery",
        battery_voltage: round2(random(13.7, 14.4)),
        current: round2(random(0.8, 3.2)),
        percentage: 100,
        room_temp: round2(random(24, 30)),
        main_status: "On",
        status: "Online",
        last_seen: formatDateTime(now),
    };
};
